import {useNavigate, useParams} from "react-router-dom";
import React, {useState} from "react";

import './style.scss'
import Footer from "../../ui/Footer";
import {useTranslation} from "react-i18next";
import Header from "../../ui/Header";
import Button from "../../ui/Button";


function TosPage({wasSearched}) {
  let {bulletinId} = useParams();
  let navigate = useNavigate()
  let {t} = useTranslation();

  let [sent, setSent] = useState(false)

  const handleSend = (data) => {
    console.log('[{name, email, question}]', data)
    fetch('/api/contact', {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    setSent(true)
  }

  return (
    <div className="dsearch-tos-page">

      <Header/>

      <div className="dsearch-tos-page__body">
        <h2>Правила использования</h2>

        <p>
          Программа для ЭВМ D-search лицензируется и тарифицируется на основе количества API Credits в месяц, доступного
          Лицензиату.
          <br/>
          <br/>
          Лицензиар заявляет и гарантирует, что:<br/>
          <ul>
            <li>Является разработчиком Программного обеспечения;</li>
            <li>Программное обеспечение предназначено для поиска уязвимостей в стороннем программном обеспечении,
              который базируется на открытых источниках в сети Интернет;
            </li>
            <li>Лицензиар является законным владельцем Программного обеспечения (за исключением любых включенных в них
              данных Лицензиата) и имеет все необходимые права на Программное обеспечение для предоставления Лицензиату
              лицензии по настоящему Соглашению;
            </li>
            <li>Программное обеспечение не нарушает требований законодательства Российской Федерации, а также авторских
              прав третьих лиц.
            </li>
          </ul>
        </p>

        <p style={{textAlign:'left', width: '100%'}}>
          <a
          href="https://d-search.ru/docs/5_D-Search_%D0%A0%D1%83%D0%BA%D0%BE%D0%B2%D0%BE%D0%B4%D1%81%D1%82%D0%B2%D0%BE_%D0%BF%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D1%8F.pdf">D-Search
          - Руководство пользователя</a>
          <br/><a
          href="https://d-search.ru/docs/8_D_Search_%D0%A0%D1%83%D0%BA%D0%BE%D0%B2%D0%BE%D0%B4%D1%81%D1%82%D0%B2%D0%BE_%D0%BF%D0%BE_%D1%83%D1%81%D1%82%D0%B0%D0%BD%D0%BE%D0%B2%D0%BA%D0%B5_%D0%B8_%D0%BD%D0%B0%D1%81%D1%82%D1%80%D0%BE%D0%B8%CC%86%D0%BA%D0%B5.pdf">D-Search
          - Руководство по установке и настройке</a>
          <br/><a
          href="https://d-search.ru/docs/9_D_Search_%D0%A4%D1%83%D0%BD%D0%BA%D1%86%D0%B8%D0%BE%D0%BD%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B5_%D1%85%D0%B0%D1%80%D0%B0%D0%BA%D1%82%D0%B5%D1%80%D0%B8%D1%81%D1%82%D0%B8%D0%BA%D0%B8.pdf">D-Search
          - Функциональные характеристики</a>
          <br/><a
          href="https://d-search.ru/docs/4_D_Search_Поддержание_жизненного_цикла.pdf">D-Search
          - Функциональные характеристики</a>
        </p>

      </div>

      <Footer/>

    </div>
  );
}

export default TosPage;
